<template>

   <iframe :src="query?`https://promo.indio.com.mx/promos/MRg8nxa?${query}`:`https://promo.indio.com.mx/promos/MRg8nxa`" frameborder="0" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>

</template>

<script>
import tagFunctions from '@/utils/tagFunctions.js'
export default {
  name: "vivelatino",
  components: {

  },
computed: {
    query(){
      return Object.keys(this.$router.currentRoute.query).map((x) => {
    return x + '=' + this.$router.currentRoute.query[x];
}).join('&');
    }
  },
  created() {},
  data() {
    return {
    }
  },
  mounted() {
    tagFunctions.evPageViewPush('Vive Latino')
  },
  methods: {},
};
</script>